import {Component, ViewChild, Input, Output, EventEmitter} from '@angular/core'
import {Agent, Role, Status, Category, Departments} from '../../models/index';
import {HttpService, DepartmentsService} from '../../services';
import {BsModalComponent} from 'ng2-bs3-modal/ng2-bs3-modal';
import {AgentsService} from "../../services/agents.service";

@Component({
    moduleId: module.id,
    selector: 'agent',
    templateUrl: 'agent.component.html',
    providers: [DepartmentsService]
})
export class AgentComponent {
    _agent: Agent = new Agent;
    public isEdit: boolean = false; // Добавляется ли новый агент.
    canEdit: boolean = true; // Наличие прав на редактирование.
    @Input() statuses: Status[] = [];
    statusesAllAgents: Status[] = [];
    @Input() roles: Role[] = [];
    @Input() categories: Category[] = [];
    departments: Departments[] = [];

    @ViewChild('modalChangePass',{static: false}) modalChangePass: BsModalComponent;

    @Input("agentId")
    set in(agentId: number) {
        if (agentId != undefined) {
            this.getAgent(agentId);
            this.isEdit = true;
        }
        else {
            this._agent = new Agent;
            this.isEdit = false;
        }
    }

    @Output() onSave = new EventEmitter();
    @Output() onCancel = new EventEmitter();

    constructor(private agentsService: AgentsService, private departmentsService: DepartmentsService) {
    }

    getStatuses() {
        return this.statuses;
    }

    getAgent(agentId: number) {
        this._agent = new Agent;
        this.agentsService.getAgent(agentId).subscribe((data) => {
            var DateBegin = new Date(data.data.DateBegin);
            data.data.DateBegin = DateBegin.getFullYear() + '-' + (DateBegin.getMonth() + 1 < 10 ? '0' : '') + (DateBegin.getMonth() + 1) + '-' + (DateBegin.getDate() < 10 ? '0' : '') + DateBegin.getDate();

            var DateEnd = new Date(data.data.DateEnd);
            data.data.DateEnd = DateEnd.getFullYear() + '-' + (DateEnd.getMonth() + 1 < 10 ? '0' : '') + (DateEnd.getMonth() + 1) + '-' + (DateEnd.getDate() < 10 ? '0' : '') + DateEnd.getDate();

            this._agent = data.data;
            this._agent.ChangePassword = data.data.ChangePassword;
        });
    }

    resetPassword() {
        if (this._agent.Id != null) {
            let agent: Agent = new Agent();
            agent.Id = this._agent.Id;
            agent.ChangePassword = false;
            this.agentsService.updateAgent(agent).subscribe(resp => {
                let r = resp;

                if (r.code)
                    alert(r.msg);
                else
                    this.onSave.emit();
            });
        } else {
            this.agentsService.addAgent(this._agent).subscribe(resp => {
                let r = resp;

                if (r.code)
                    alert(r.msg);
                else
                    this.onSave.emit();
            });
        }
    }

    save(valid?) {
        if (!valid) {
            alert("Заполните обязательные поля");
            return;
        }
        if (this._agent.RoleId == -1) {
            alert("Заполните обязательные поля");
            return;
        }
        
        if (this._agent.Id != null) {
            this.agentsService.updateAgent(this._agent).subscribe(resp => {
                let r = resp;

                if (r.code)
                    alert(r.msg);
                else
                    this.onSave.emit();
            });
        } else {
            this.agentsService.addAgent(this._agent).subscribe(resp => {
                let r = resp;

                if (r.code)
                    alert(r.msg);
                else
                    this.onSave.emit();
            });
        }
    }

    cancel() {
        this._agent = new Agent();
        this.isEdit = false;
        this.onCancel.emit();
    }

    changePass() {
        this.isEdit = !this.isEdit;
        // this.modalChangePass.open();
    }

    saveChangesPass() {
        this.save();
        this.modalChangePass.close();
    }

    closeChangePass() {
        this.modalChangePass.close();
    }

    ngOnInit() {
        this.agentsService.getStatusesAgents().subscribe((data) => {
            this.statusesAllAgents = data.data;
        });

        this.departmentsService.getDepartments().subscribe((data) => {
            this.departments = data.data;
        });


    }

    ngOnDestroy() {
        this.isEdit = false;
    }

    checkSelect(role, _agent) {
        return role.Id == _agent.RoleId && _agent.Id != null;
    }

}